import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  FormGroup, Button, Label, FormText,
} from 'reactstrap';
import {
  Field, reduxForm, change, formValueSelector, startSubmit,
} from 'redux-form';
import { Elements } from '@stripe/react-stripe-js';
import { renderInput, required } from '../../helpers/formHelper';
import AddNewCardForm from './AddNewCardForm';
import CheckoutWithPaymentMethod from './CheckoutWithPaymentMethod';

class View extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
    this.method = React.createRef();
  }

  render() {
    const {
      hiddenFields, displays, formValues, submitting,
    } = this.props;
    return (
      <>
        {/* サーバー用フォーム */}
        <form action={displays.action} method="post" ref={this.form} onSubmit={() => this.props.setSubmittingState('Credit')}>
          <Field name="authenticity_token" type="hidden" component="input" />
          <div dangerouslySetInnerHTML={{ __html: hiddenFields }} />
          <Field name="stripe[payment_intent_id]" type="hidden" component="input" />
          <Field name="stripe[new_payment_method_id]" type="hidden" component="input" />
          {displays.method !== undefined && <input name="_method" type="hidden" value={displays.method} ref={this.method} />}
          <hr />
          {(displays.cards.length > 1 || formValues.stripe.payment_method_id === 'new') && (
            <FormText color="danger" style={{ marginBottom: '1.5rem' }}>
              【ライフイズテック スクールにご参加の方へ】
              <br />
              今回新規に入力された・または選択されたクレジットカードが、受講料のお支払いクレジットカードとなります。
              <br />
              ※マイページから変更が可能です。
            </FormText>
          )}
          <FormGroup>
            {displays.cards.length > 0 ? (
              <>
                <Label>クレジットカード情報</Label>
                <Field
                  name="stripe[payment_method_id]"
                  type="select"
                  component={renderInput}
                  validate={[required]}
                  id="payment_method_id"
                >
                  <option value="new">新規登録</option>
                  {displays.cards.map((x) => <option key={x.id} value={x.id}>{x.option_name}</option>)}
                </Field>
              </>
            ) : <Field name="stripe[payment_method_id]" type="hidden" component="input" />}
          </FormGroup>
        </form>
        {/* クライアント決済用フォーム */}
        {formValues.stripe.payment_method_id === 'new' ? (
          <Elements stripe={this.props.stripePromise}>
            <AddNewCardForm
              client_secret={displays.client_secret}
              submitCreditForm={(payment_method_id) => {
                // React 18対応: DOMを直接更新してからsubmit
                const hiddenInput = this.form.current.querySelector('input[name="stripe[new_payment_method_id]"]');
                if (hiddenInput) {
                  hiddenInput.value = payment_method_id;
                }
                this.props.dispatch(change('Credit', 'stripe[new_payment_method_id]', payment_method_id));
                if (!this.props.submitting) {
                  this.form.current.submit();
                }
              }}
            />
          </Elements>
        ) : (
          <Elements stripe={this.props.stripePromise}>
            <CheckoutWithPaymentMethod
              submitting={this.props.submitting}
              client_secret={displays.client_secret}
              payment_method_id={formValues.stripe.payment_method_id}
              submitForm={() => {
                if (!this.props.submitting) {
                  this.form.current.submit();
                }
              }}
            />
          </Elements>
        )}
        {/* もどるボタン */}
        <form action="back" method="post">
          <Field name="authenticity_token" type="hidden" component="input" />
          <div dangerouslySetInnerHTML={{ __html: hiddenFields }} />

          <Button
            className="back"
            color="secondary"
            size="lg"
            onClick={(e) => {
              e.preventDefault();
              this.form.current.action = 'back';
              if (displays.method !== undefined) {
                this.method.current.value = 'post';
              }
              this.form.current.submit();
            }}
            disabled={submitting}
          >
            もどる
          </Button>
        </form>
      </>
    );
  }
}

View.propTypes = {
  hiddenFields: PropTypes.string.isRequired,
  displays: PropTypes.shape({
    cards: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      option_name: PropTypes.string.isRequired,
    })),
    action: PropTypes.string.isRequired,
    method: PropTypes.string,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  formValues: PropTypes.shape({
    authenticity_token: PropTypes.string,
    stripe: PropTypes.shape({
      payment_method_id: PropTypes.string,
    }),
  }).isRequired,
  setSubmittingState: PropTypes.func.isRequired,
  stripePromise: PropTypes.object.isRequired,
};

const selector = formValueSelector('Credit');
export default reduxForm({
  form: 'Credit',
  validate: () => {
    const errors = {};
    return errors;
  },
})(connect((state) => ({
  formValues: selector(
    state,
    'authenticity_token',
    'stripe.payment_method_id',
    'stripe.payment_intent_id'
  ),
}), (dispatch) => ({
  setSubmittingState: (formId) => {
    dispatch(startSubmit(formId));
  },
}))(View));
